// ScaleProvider.jsx
import React, { createContext, useEffect } from 'react';

export const ScaleContext = createContext();

export function ScaleProvider({ children }) 
{
  useEffect(() => 
  {
    const updateBaseFont = () => 
    {
      
      //const designW = 3840;  // the width you designed against
      const { innerWidth } = window;


      // pick the smaller ratio so you never overflow vertically or horizontally
//      const scale = Math.min(innerWidth / designW, innerHeight / (designW * 9/16));
      //const scale = Math.min(innerWidth / designW);

      // clamp between 0.75 and 1.25 so your fonts never get absurdly tiny or huge
      //const clamped = Math.max(0.75, Math.min(scale, 1.25));
      
      let font_size = 22

      if (innerWidth < 3200) font_size = 16

      if (innerWidth < 2240) font_size = 12


      document.documentElement.style.fontSize = `${font_size}px`;

  //    console.log('W/H', innerWidth, innerHeight)      
  //    console.log('Scale',  scale)
  //    console.log('Clamped', clamped)
      console.log('Font Size', document.documentElement.style.fontSize)
    };

    updateBaseFont();
    window.addEventListener('resize', updateBaseFont);
    return () => window.removeEventListener('resize', updateBaseFont);
  }, []);

  return <ScaleContext.Provider value={{}}>{children}</ScaleContext.Provider>;
}
